import { useState, useEffect } from 'react';
import VersioningWorker from '@app/workers/versioning.worker?worker';
import {
  Button, Dialog, Flex, Text
} from '@huspy/briks-web';
import { VStack } from '@huspy/styled-system/jsx';
import { imagesPath } from '@shared/css.const';
import { useTranslation } from 'react-i18next';

const worker = new VersioningWorker();
const sseUrl = '/app-version';

const hardReload = () => {
  window.location.reload();
};

const workerInit = (onNewVersionHandle: () => void) => {
  if (ENV === 'local') {
    return;
  }
  worker.postMessage({ action: 'connect', url: sseUrl });

  // eslint-disable-next-line unicorn/prefer-add-event-listener
  worker.onmessage = (event) => {
    const { type, data } = event.data;

    if (type === 'message') {
      // eslint-disable-next-line no-console
      console.log('New app version available:', data);
      if (!!data && data !== 'undefined' && data !== APP_GIT_COMMIT_HASH) {
        onNewVersionHandle();
      }
    } else if (type === 'error') {
      // eslint-disable-next-line no-console
      console.error('SSE error:', event);
    }
  };
};

export const NewVersion = () => {
  const [showUpdateAppModal, setShowUpdateAppModal] = useState(false);
  useEffect(() => {
    workerInit(
      () => setShowUpdateAppModal(true)
    );
  }, []);

  const { t } = useTranslation();
  return (
    <Dialog.Root
      lazyMount
      unmountOnExit
      open={ showUpdateAppModal }
    >
      <Dialog.Backdrop style={ { zIndex: 999999 } } />
      <Dialog.Positioner style={ { zIndex: 9_999_999 } }>
        <Dialog.Content style={ { width: '500px' } } data-testid='update-app-version-dialog'>
          <VStack gap='6' p='spacing-8'>
            <img
              alt='Update application'
              height='72px'
              width='72px'
              src={ `${imagesPath}/new-app-version.png` }
            />
            <Flex direction='column' justifyContent='center' alignItems='center'>
              <Text size='2xl' weight='semiBold'>
                {t('common.updateAppModal.newVersionAvailable')}
              </Text>
              <Text size='md' weight='medium' color='text-secondary'>
                {t('common.updateAppModal.subtitle')}
              </Text>
              <Text size='md' weight='medium' color='text-secondary'>
                {t('common.updateAppModal.subtitle2')}
              </Text>
            </Flex>
            <Button w='100%' onClick={ hardReload } data-testid='refresh-app-btn'>
              {t('common.updateAppModal.refresh')}
            </Button>
          </VStack>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
